import { useEffect, useState } from "react";
import { IndianRupee } from "lucide-react";
import PartnerGate from "./Gate";
import { EmptyState, StatCard, StatusBadge, inr } from "@/components/bits";
import api, { fmtDate } from "@/lib/api";

export default function Earnings() {
  const [payouts, setPayouts] = useState([]);
  useEffect(() => {
    api.get("/partner/payouts").then(({ data }) => setPayouts(data.payouts)).catch(() => {});
  }, []);

  return (
    <PartnerGate>
      {(overview) => (
        <div data-testid="partner-earnings">
          <div className="grid sm:grid-cols-2 gap-5 mb-6">
            <StatCard label="Pending / Eligible" value={inr(overview.earnings_pending)} icon={IndianRupee} />
            <StatCard label="Paid Out" value={inr(overview.earnings_paid)} icon={IndianRupee} accent />
          </div>
          {payouts.length === 0 ? (
            <EmptyState title="No payouts yet" description="Payouts become eligible when your candidates join. The Partner Agreement and Commercial Schedule govern exact payouts." testId="payouts-empty" />
          ) : (
            <div className="space-y-3">
              {payouts.map((p) => (
                <div key={p.id} className="bg-white border border-border/60 rounded-xl p-5 flex items-center justify-between gap-4" data-testid={`payout-${p.id}`}>
                  <div>
                    <p className="font-semibold text-sm text-[#0B1B3D]">{p.ref?.candidate} — {p.ref?.job_title}</p>
                    <p className="text-xs text-muted-foreground mt-1">
                      {fmtDate(p.created_at)}
                      {p.payout_tier && ` · ${p.payout_tier} tier`}
                      {p.franchise_boost_pct ? ` · +${p.franchise_boost_pct}% franchise boost` : ""}
                    </p>
                  </div>
                  <div className="flex items-center gap-3">
                    <span className="font-heading font-bold">{inr(p.amount)}</span>
                    <StatusBadge status={p.status} />
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </PartnerGate>
  );
}
